import React from 'react';
import certificationsData from '../config/certifications';
import './styles/Certifications.scss'; // We'll create this SCSS file next

const Certifications = () => {
  return (
    <section id="certifications" className="certifications">
      <h2 className="certifications__title">Certifications</h2>
      <div className="certifications-scroll-container">
        {certificationsData.map((cert) => (
          <a
            key={cert.id}
            href={cert.url}
            target="_blank"
            rel="noopener noreferrer"
            className="certificate-card"
            title={`View ${cert.title} Certificate`}
          >
            <img
              src={cert.image}
              alt={cert.title}
              className="certificate-image"
            />
            {/* Optional: You can add title text below the image if you like */}
            {/* <p className="certificate-title">{cert.title}</p> */}
          </a>
        ))}
      </div>
    </section>
  );
};

export default Certifications;